import { NextPage } from "next";
import Head from "next/head";
import Header from "components/gonzo/Header";
import Footer from "components/official/footer/Footer";
import Campaign from "components/gonzo/Campaign";
import Illustration from "components/gonzo/Illustration";
import CrowdFunding from "components/gonzo/CrowdFunding";
import Exhibition from "components/gonzo/Exhibition";
import Main from "components/gonzo/parts/Main";
import AnchorTarget from "components/official/AnchorTarget";
import BackToTop from "components/official/BackToTop";
import News from "components/gonzo/News";
import Background from "components/gonzo/parts/Background";
import { LibraryContextProvider } from "lib/context/gonzo/LibraryContext";
import KeyVisualScroll from "components/gonzo/KeyVisualScroll";
import Message from "components/gonzo/Message";
import { useEffect, useMemo } from "react";
import Copyright from "components/gonzo/Copyright";

const GonzoLp: NextPage = () => {
  const baseUrl = process.env.BASE_URL;
  const robotsValue = useMemo(() => {
    return process.env.APP_ENV === "production" ? "all" : "noindex";
  }, []);
  useEffect(() => {
    document.body.style.backgroundColor = "#000";
  }, []);
  return (
    <>
      <Head>
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        <title>『GONZO30周年アニバーサリー』特設ページ｜アニメファンド</title>
        <meta name="description" content="GONZO設立30周年を記念して、プレゼントキャンペーンやクラウドファンディングなど様々な企画を用意しています。" />
        <meta name="keywords" content="アニメクラファン,クラファン,GONZO30周年,GONZO30th" />
        <meta property="og:title" content="『GONZO30周年アニバーサリー』特設ページ" />
        <meta property="og:description" content="GONZO設立30周年を記念して、プレゼントキャンペーンやクラウドファンディングなど様々な企画を用意しています。" />
        <meta property="og:image" content={`${baseUrl}/project-preview/omnigraph/gonzo30th.jpeg`} />
        <meta property="og:url" content={`${baseUrl}/lp/gonzo`} />
        <meta property="og:site_name" content="アニメファンド" />
        <meta property="og:locale" content="ja_JP" />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@animefund" />
        <meta property="fb:app_id" content="2809748165906745" />
        <link rel="canonical" href={`${baseUrl}/lp/gonzo`} />
        <meta name="robots" content={robotsValue} />
      </Head>
      <LibraryContextProvider>
        <Header />
        <Background />
        <Main>
          <AnchorTarget id="page_top" />
          <KeyVisualScroll />
          <News />
          <Campaign />
          <Illustration />
          <CrowdFunding />
          <Exhibition />
          <Message />
          <Copyright />
        </Main>
        <Footer />
        <BackToTop />
      </LibraryContextProvider>
    </>
  );
};
export default GonzoLp;
